import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { Skeleton } from '@material-ui/lab';
import { missionControlURL } from 'Hooks/useMissionControlURL';
import WeeklyCalendarEvent from './WeeklyCalendarEvent';

const ISO_WEEKDAYS = [1, 2, 3, 4, 5, 6, 7];

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: theme.palette.common.white,
    borderRadius: '13px',
    padding: theme.spacing(3),
  },
  loading: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    borderRadius: '13px',
    padding: theme.spacing(3),
  },
  calendarDay: {
    display: 'flex',
    flexDirection: 'column',
    width: '130px',
    padding: theme.spacing(0, 1),
    height: '100%',
  },
  label: {
    textAlign: 'left',
    color: theme.palette.facet.primaryGray,
    ...theme.typography.h6,
  },
  labelDate: {
    textAlign: 'left',
    fontSize: theme.typography.h6.fontSize,
    fontWeight: '300',
    color: theme.palette.facet.primaryGray,
  },
  events: {
    position: 'relative',
    marginTop: '10px',
    height: '100%',
  },
});

const sortDescending = (a, b) => new Date(a.attr('startTime')).valueOf()
  - new Date(b.attr('startTime')).valueOf();

const filterClientMeetings = (meetingCollection, isoWeekDay) => meetingCollection.filter((ce) => {
  // Must be on the correct day
  return isoWeekDay % 7 === moment(ce.attr('startTime')).isoWeekday();
});

function WeeklyCalendar({
  className,
  classes,
  date,
  meetingCollection,
  weeklyMeetingCollectionLoading,
}) {
  return (
    <>
      {weeklyMeetingCollectionLoading ? (
        <Skeleton animation="wave" variant="rect" className={classes.loading} />
      ) : (
        <div className={classNames(classes.root, className)}>
          {ISO_WEEKDAYS.map(i => (
            <div className={classes.calendarDay} key={`day.${i}`}>
              <div className={classes.label}>
                {moment()
                  .startOf('week')
                  .add(i, 'day')
                  .format('ddd')}
              </div>
              <div className={classes.labelDate}>
                {moment(date)
                  .startOf('week')
                  .add(i, 'day')
                  .format('MMM D')}
              </div>
              <div className={classes.events}>
                {filterClientMeetings(meetingCollection, i)
                  .sort(sortDescending)
                  .filter(resource => resource.attr('householdId') > 0)
                  .map((resource, j) => (
                    <WeeklyCalendarEvent
                      key={`event.${i}.${j}`} // eslint-disable-line react/no-array-index-key
                      meetingType={resource.attr('meetingType')}
                      title={resource.attr('title')}
                      startTime={resource.attr('startTime')}
                      endTime={resource.attr('endTime')}
                      bestNextSteps={resource.attr('bestNextSteps')}
                      householdId={resource.attr('householdId')}
                      missionControlURL={missionControlURL(resource, resource.attr('householdId'), { meetingSelfLink: resource.link('self').url() })}
                      status="accepted" // TODO: change this when we are fetching event status
                    />
                  ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}

WeeklyCalendar.defaultProps = {
  className: '',
  weeklyMeetingCollectionLoading: false,
};

WeeklyCalendar.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  date: PropTypes.object.isRequired,
  meetingCollection: PropTypes.array.isRequired,
  weeklyMeetingCollectionLoading: PropTypes.bool,
};

export default withStyles(styles, { name: 'WeeklyMeetings' })(WeeklyCalendar);
